import React from 'react';
import { RxCross1 } from 'react-icons/rx';

const SharedRightSlideout = ({
  isOpen,
  onClose,
  title,
  subtitle,
  className = '',
  bodyClassName = '',
  children,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="avatar-dropdown-menu-overlay shared-right-slideout-overlay" onClick={onClose}>
      <aside
        className={`avatar-dropdown-menu-popup shared-right-slideout-popup ${className}`.trim()}
        onClick={(event) => event.stopPropagation()}
        aria-modal="true"
        role="dialog"
        aria-label={title || 'Slideout tray'}
      >
        <button
          type="button"
          className="slider-tray-close-button shared-right-slideout-close-button"
          onClick={onClose}
          aria-label="Close tray"
        >
          <RxCross1 size={25} className="avatar-dropdown-menu-close-btn" />
        </button>

        {(title || subtitle) && (
          <header className="shared-right-slideout-header">
            {title && <h2 className="shared-right-slideout-title">{title}</h2>}
            {subtitle && <p className="shared-right-slideout-subtitle">{subtitle}</p>}
          </header>
        )}

        <div className={`shared-right-slideout-body ${bodyClassName}`.trim()}>
          {children}
        </div>
      </aside>
    </div>
  );
};

export default SharedRightSlideout;
